var React = require('react');

function Glamour (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M716.9 814.1H788v5.4H572v-5.4h69.3l-90.9-264.6H377.6l-90.9 264.6H356v5.4H212v-5.4h70.2c36.6-106.2 73-211.6 109.3-316.4C427.8 393.1 464 287.3 500 180.5c11.4 33.6 21.2 62 29.2 85.1 8.1 23.1 15 43.2 20.7 60.3 5.7 17.1 10.9 32.7 15.8 46.8 4.8 14.1 10 29.2 15.8 45.4 5.7 16.2 12 34.7 18.9 55.3 6.9 20.7 15.6 46.2 26.1 76.5 10.5 30.3 23.1 66.9 37.8 109.8 14.6 43 32.2 94.4 52.6 154.4zm-337.5-270h169.2L464 298.4l-84.6 245.7z"}));
}

Glamour.defaultProps = {"viewBox":"0 0 1000 1000"};

module.exports = Glamour;

Glamour.default = Glamour;
